<template>
  <div class="preview-progress" :class="classes">
    <div class="preview-progress__rail" ref="rail" @click.stop="handleRailClick" @mousedown="handleMousedown" @touchstart="handleMousedown">
      <span class="preview-progress__slider" ref="slider" @click.stop :style="sliderStyles"></span>
      <span class="preview-progress__value" :style="{ width: `${progress * 100}%` }"></span>
    </div>
  </div>
</template>

<script>
import { addEvent } from '@/utils/event'

export default {
  name: 'PreviewProgress',
  props: {
    type: {
      type: String,
      default: 'scale'
    },
    initValue: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isMoving: false,
      progress: 0,
      position: {},
      cancelEvents: []
    }
  },
  computed: {
    classes() {
      return {
        [`is-${this.type}`]: !!this.type
      }
    },
    sliderStyles() {
      return {
        left: `${this.progress * 100}%`
      }
    }
  },
  watch: {
    progress(val) {
      this.$emit('change', val)
    }
  },
  created() {
    if (this.initValue) {
      this.progress = this.initValue
    }
  },
  mounted() {
    this.initEvent()
    this.handleResize()
    this.$topic.subscribe('preview.reset', this.reset)
  },
  beforeDestroy() {
    this.cancelEvents.forEach(cb => cb())
  },
  methods: {
    reset() {
      this.progress = 0
    },
    updateProgress(progress) {
      this.progress = progress
    },
    initEvent() {
      const handleMousemove = this.throttle(this.handleMousemove)
      const resize = addEvent(window, 'resize', this.handleResize)
      const mouseup = addEvent(document.body, 'mouseup', this.handleMouseup)
      const touchend = addEvent(document.body, 'touchend', this.handleMouseup)
      const touchmove = addEvent(document.body, 'touchmove', handleMousemove)
      const mousemove = addEvent(document.body, 'mousemove', handleMousemove)

      this.cancelEvents = [resize, mouseup, touchend, touchmove, mousemove]
    },
    handleResize() {
      const { width, left } = this.$refs.rail.getBoundingClientRect()

      this.position = { width, left }
    },
    handleRailClick({ offsetX }) {
      const { width } = this.position
      const progress = parseInt((offsetX / width * 100)) / 100

      this.progress = progress
    },
    handleMousedown() {
      this.isMoving = true
    },
    handleMousemove(evt) {
      if (this.isMoving) {
        const { width, left } = this.position
        let position = (evt.touches ? evt.touches[0] : evt).clientX - left

        position = position < 0 ? 0 : position > width ? width : position

        this.handleRailClick({ offsetX: position })
      }
    },
    handleMouseup() {
      this.isMoving = false
    },
    throttle(fn, delay = 100) {
      let last = 0

      return (...args) => {
        const current = new Date().getTime()
        if (current - last > delay) {
          fn.apply(this, args)
          last = current
        }
      }
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');
  .preview-progress {
    flex: 1;
    &.is-scale {
      .preview-progress__rail {
        width: 80px;
      }
    }
    & &__rail {
      position: relative;
      width: 100%;
      height: 6px;
      border-radius: 3px;
      background-color: var(--background-contrl-rail, #BBBDC0);
      cursor: pointer;
    }
    & &__slider {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 2;
      transform: translate(-50%, -50%);
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #F1F1F1;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
      transition: left linear .2s;
    }
    & &__value {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      transform: translateY(-50%);
      width: 0;
      height: 100%;
      border-radius: 3px;
      background-color: var(--background-contrl-rail-value, @grey-600);
      transition: width linear .2s;
    }
  }
</style>
